import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))
function RA_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <RA_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <RA_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function RA_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
             What is Regulatory Affairs and why is it important?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Regulatory Affairs (RA) ensures that pharmaceuticals, medical devices, food, and biotech products comply with laws and regulations. It plays a critical role in safeguarding public health, product quality, and global market access.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              Why should students consider learning about Regulatory Affairs?

            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Because RA is a fast-growing field in healthcare, pharma, and biotech with strong career opportunities. Students gain skills that make them industry-ready and globally employable.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              Why is Regulatory Affairs considered a stable career option?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
             Because healthcare and pharma industries are always growing, RA professionals are in high demand worldwide with strong job security.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What is the future of Regulatory Affairs?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              With the growth of biologics, nanomedicine, personalized medicine, and digital health technologies, the demand for skilled RA professionals will continue to rise.
            </Typography>
          </AccordionDetails>
        </Accordion>
        {/* <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What are the potential career paths and growth opportunities in
              AI?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              AI offers numerous career growth opportunities, including moving
              into leadership roles such as AI team lead or chief data officer.
              Professionals can also specialize further in specific areas of AI,
              like deep learning or robotics, or transition into related fields
              such as data analytics, business intelligence, or software
              engineering.
            </Typography>
          </AccordionDetails>
        </Accordion> */}
      </div>
    </>
  )
}
export default RA_FAQ_page
